"use strict";

exports.__esModule = true;
exports.default = void 0;
var _findLastIndex = _interopRequireDefault(require("./findLastIndex.js"));
var _createIndexFinder = _interopRequireDefault(require("./_createIndexFinder.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
var _default = exports.default = (0, _createIndexFinder.default)(-1, _findLastIndex.default);